module.exports = __webpack_public_path__ + "static/media/Nardi.0a036fd5.png";